// extracted by mini-css-extract-plugin
export default {"container":"W2-z","list":"X2-z"};